import "./Home.module.css";
import CommandCenterHeader from "@/reusable_sections/Header";
import NeverMissALeadAgain from "./sections/NeverMissALeadAgain";
import TheGrowthArsenal from "./sections/TheGrowthArsenal";
import VeteranOwnedReliability from "./sections/VeteranOwnedReliability";
import MissionImpactMetrics from "./sections/MissionImpactMetrics";
import IntelligenceReports from "./sections/IntelligenceReports";
import SecureYourPerimeter from "./sections/SecureYourPerimeter";
import BaseOperationsFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <CommandCenterHeader />
      <NeverMissALeadAgain />
      <TheGrowthArsenal />
      <VeteranOwnedReliability />
      <MissionImpactMetrics />
      <IntelligenceReports />
      <SecureYourPerimeter />
      <BaseOperationsFooter />
    </div>;
}